import { Component, computed, input } from '@angular/core'
import { capitalize } from '../../util'
import { Illustration, ILLUSTRATION_ASSET_PATH, ILLUSTRATION_DEFAULT_SIZE } from './illustration'

@Component({
  standalone: true,
  selector: 'ftr-illustration',
  templateUrl: './illustration.component.html',
})
export class IllustrationComponent {
  illustration = input.required<Illustration>()

  // optional overrides
  width = input<number>(ILLUSTRATION_DEFAULT_SIZE)
  height = input<number>(ILLUSTRATION_DEFAULT_SIZE)
  alt = input<string>()

  protected readonly altText = computed(() => this.alt() ?? this.inferAltText())
  protected readonly sourcePath = computed(() => `${ILLUSTRATION_ASSET_PATH}/${this.illustration()}.svg`)

  // e.g. 'audit-log' becomes 'Audit log illustration'
  private inferAltText(): string {
    return `${capitalize(this.illustration().replace(/-/g, ' '))} illustration`
  }
}
